import { styled } from "styled-components";
import bg from "../../assets/bg.jpg";

const HomeDetails = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;

  user-select: none;

  .hero-section {
    width: 100%;
    height: 100vh;
    background-image: url(${bg});
    background-position: center;
    background-repeat: no-repeat;

    display: flex;
    align-items: center;
    justify-content: center;

    padding: 0px 20px;

    .content-hero {
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 1250px;
      z-index: 2;
      gap: 10px;

      h1 {
        width: 100%;
        max-width: 600px;
        color: white;
        font-size: 5rem;
        margin: 0;
      }

      p {
        width: 100%;
        max-width: 600px;
        margin: 0;
        color: white;
        font-size: 1.5rem;
        font-weight: 500;
      }

      span {
        color: #df8925;
      }
    }

    @media (max-width: 600px) {
      height: 80vh;
      .content-hero {
        h1 {
          font-size: 3rem;
        }

        p {
          font-size: 1.3rem;
        }
      }
    }

    @media (max-width: 370px) {
      .content-hero {
        h1 {
          font-size: 2.5rem;
        }
      }
    }
  }

  .apresentation {
    width: 100%;

    background-color: #fbfafafd;

    display: flex;
    justify-content: center;
    padding: 50px 20px;

    .content-apresentation {
      width: 100%;
      max-width: 1200px;

      display: flex;
      gap: 50px;

      @media (max-width: 600px) {
        flex-direction: column;
      }

      .apresentation-clomun {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 30px;

        align-items: center;

        .icon {
          width: 50px;
          height: 50px;

          background-color: #df8925;

          border-radius: 50%;

          display: flex;
          justify-content: center;
          align-items: center;

          font-size: 1.4rem;
          color: white;
        }

        .title-column {
          color: rgb(28, 32, 17);
          font-size: 1.2rem;
          font-weight: 600;
          text-align: center;
        }

        .desc {
          text-align: center;
        }
      }
    }
  }

  .section {
    padding: 0px 10px;
    width: 100%;
    max-width: 1200px;
    margin: 50px 0px 30px 0px;
  }

  .section-full-width {
    display: flex;
    justify-content: center;
    align-items: center;

    flex-direction: column;

    padding: 0px 10px;
  }

  .content-section-full-width {
    width: 100%;
    max-width: 1200px;
    padding: 50px 0px;
    background: #f9f9f9;
  }

  .title-section {
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;

    .slug {
      font-weight: 500;
      font-size: 2.5rem;
    }

    .line {
      width: 100px;
      height: 3px;
      background: #df8925;
      border-radius: 26px;
    }
  }

  .title-content {
    margin: 50px 0px;
    width: 100%;
    max-width: 1200px;
    padding: 0px 20px;

    display: flex;
    flex-direction: column;
    align-items: center;

    .line {
      width: 150px;
      height: 5px;

      background-color: #df8925;

      border-radius: 19px;
    }

    @media (max-width: 360px) {
      h1 {
        font-size: 1.5rem;
      }
    }
  }

  .content {
    width: 100%;
    max-width: 1200px;
    padding: 0px 10px;
    margin: 50px 0px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 50px;

    .sidebar {
      width: 100%;
      display: flex;
      flex-direction: column;

      gap: 20px;

      p {
        text-align: justify;
        letter-spacing: 1px;
        font-size: 1.1rem;
        line-height: 25px;
      }
    }
  }

  .list-section {
    display: grid;

    grid-template-columns: 1fr 1fr 1fr 1fr;

    row-gap: 30px;
    column-gap: 20px;

    margin-top: 50px;

    @media (max-width: 1170px) {
    }

    @media (max-width: 950px) {
      display: grid;

      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 1fr;

      row-gap: 30px;
      column-gap: 30px;
    }

    @media (max-width: 500px) {
      display: flex;
      flex-direction: column;
    }
  }

  .item-list {
    flex-basis: 280px;

    @media (max-width: 1170px) {
      flex-basis: 300px;
    }
  }

  .swiper-title {
    color: #f9f9f9;
    position: absolute;
    bottom: 100px;
    left: 50px;

    text-shadow: 1px 1px 1px #000;

    @media (max-width: 550px) {
      left: 20px;
    }
  }

  .swiper-chip {
    position: absolute;
    bottom: 60px;
    left: 70px;

    @media (max-width: 550px) {
      left: 40px;
    }
  }

  .swiper-pagination-bullet {
    background-color: #df8925;
    width: 10px;
    height: 10px;
    opacity: 1;
  }

  .swiper-pagination-bullet-active {
    width: 13px;
    height: 13px;
  }
`;

export default HomeDetails;
